import { useSetAtom } from 'jotai';
import { PropsWithChildren, useEffect, useState } from 'react';
import { GenericFallbacksWrapper } from '../components/Fallback/GenericFallbacksWrapper';
import { ModalProvider } from '../components/Modal/ModalContext';
import { ToastMessageProvider } from '../components/ToastMessage/ToastMessageProvider';
import { PermissionService } from '../services/PermissionService';
import { authenticatedUserState } from '../services/state/AuthState';
import { getDebugData } from './debugUser';
import { useDebugKeyboard } from './useDebugKeyboard';

export function DebugAuthProvider({ children }: PropsWithChildren) {
  const setUser = useSetAtom(authenticatedUserState);
  const [ready, setReady] = useState(false);

  useEffect(() => {
    const data = getDebugData();
    if (!data) {
      console.error('[fd-debug] No debug data found in localStorage.');
      return;
    }
    setUser(data.fronteggUser);
    PermissionService.initService(data.fronteggUser);
    console.log('[fd-debug] Debug mode active — bypassing Frontegg auth.');
    setReady(true);
  }, [setUser]);

  useDebugKeyboard();

  if (!ready) {
    return null;
  }

  return (
    <GenericFallbacksWrapper>
      <ToastMessageProvider>
        <ModalProvider>{children}</ModalProvider>
      </ToastMessageProvider>
    </GenericFallbacksWrapper>
  );
}
